import { render } from "./SwipeActivity.vue?vue&type=template&id=728e4bb4"
import script from "./SwipeActivity.vue?vue&type=script&lang=js"
export * from "./SwipeActivity.vue?vue&type=script&lang=js"

import "./SwipeActivity.vue?vue&type=style&index=0&id=728e4bb4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__